import PropTypes from 'prop-types';

import styles from './CalendarButton.scss';

export const CalendarButton = ({
  isVisible = false,
  onClick = null,
  buttonClassName,
  buttonText,
}) => {
  const classNames = [styles.CalendarNavBtn, styles[buttonClassName], isVisible && styles.invisible]
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" onClick={onClick} className={classNames}>
      {buttonText}
    </button>
  );
};

CalendarButton.propTypes = {
  isVisible: PropTypes.bool,
  onClick: PropTypes.func,
  buttonClassName: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};
